export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            意见反馈、内容投稿、商务合作，欢迎随时联系
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/60">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">投稿邮箱</h3>
                <p className="text-sm text-foreground-600">submit@pipicinema.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-chat-smile-2-line text-xl"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">意见反馈</h3>
                <p className="text-sm text-foreground-600">feedback@pipicinema.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                  <i className="ri-briefcase-line text-xl"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">商务合作</h3>
                <p className="text-sm text-foreground-600">biz@pipicinema.com</p>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-background-200/60">
              <p className="text-xs text-foreground-500 text-center leading-relaxed">
                我们重视每一位用户的反馈与建议。如需内容合作、版权问题或广告投放，请通过以上方式联系我们，
                工作日 24 小时内回复。同时欢迎优质内容创作者加入我们，一起打造更好的追剧平台。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}